<template>
<div class="container">
  <div class='topSpacing'></div>
  <div class='login-form-wrapper'>
    <div class="card p-4">
    <div class="card-body">
      <div class='logo-area'>
        <img class='logo' src='../../assets/images/ggcom.png'>
      </div>
      <div class='language-area'>
        <div>
          <CDropdown 
            :toggler-text='this.getLanguageOPT[this.getLanguageIndex]' 
            class="m-2"
            color="secondary">
            <div v-for="(data,index) in this.getLanguageOPT">
              <CDropdownItem @click="btnChgLang(index)">
                <a class="dropdown-item">
                  <span class="flagClass cif-gb" v-if="index==0"></span>
                  <span class="flagClass cif-cn" v-if="index==1"></span>
                  <span class="flagClass cif-id" v-if="index==2"></span>
                  <span class="flagClass cif-vn" v-if="index==3"></span>
                  <span class="flagClass cif-th" v-if="index==4"></span>
                  <span class="flagClass cif-kh" v-if="index==5"></span>
                  <span>{{ data }}</span>
                </a>
              </CDropdownItem>
            </div>
          </CDropdown>
        </div>
      </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">
                <i class="c-icon cil-user"></i>
            </span>
          </div>
        <input class="form-control" type="text" :placeholder='this.getLanguage["LG"]["UM"]' v-model="form['username']">
        </div>
        <div class="input-group mb-4">
          <div class="input-group-prepend">
            <span class="input-group-text">
                <i class="c-icon cil-lock-locked"></i>
            </span>
          </div>
          <input class="form-control" type="password" :placeholder='this.getLanguage["LG"]["PW"]'  @keypress.enter="Login()" v-model="form['password']">
        </div>
      <div class="row">
        <div class="col-6">
          <button class="btn btn-success px-4" type="button" @click="Login()">{{this.getLanguage["LG"]["LO"]}}</button>
        </div>
      </div>
    </div>
  </div>
  </div>

</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

import icons from '../../../node_modules/@coreui/icons/css/all.min.css'
import flag from '../../../node_modules/@coreui/icons/css/flag.min.css'

export default {
  data () {
    return {
      form: {}
    }
  },
  computed:{
	...mapGetters('Language', [
    'getLanguage',
    'getLanguageOPT',
    'getLanguageIndex',
    'getLangTreeSelect'
    ]),
  },
  methods: {
    ...mapActions('Language', [
      'setLanguage',
      'setLanguageIndex'
      ]),
    Login(){
      if(this.form.username=="admin" && this.form.password=="admin"){
        this.$parent.userrole = "/Dashboard_Admin";
        this.$parent.userType = "Super Admin";
        this.$router.push("/Dashboard_Admin");
      }else if(this.form.username=="marketing" && this.form.password=="marketing"){
        this.$parent.userrole = "/Dashboard_Marketing";
        this.$parent.userType = "Marketing";
        this.$router.push("/Dashboard_Marketing");
      }else if(this.form.username=="cs" && this.form.password=="cs"){
        this.$parent.userrole = "/Dashboard_CS";
        this.$parent.userType = "CS";
        this.$router.push("/Dashboard_CS");
      }
    },
    btnChgLang(index){
      this.setLanguageIndex(index);
      this.$root.GetData.getLanguage(this, this.getLangTreeSelect[this.getLanguageIndex].id);
    }
  }
}
</script>

<style>
.topSpacing{
  height: 30%;
  min-height: 80px;
}
.logo-area{
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
}
.logo{
  height: 100px;
}
.language-area{
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 10px;
  right: 10px;
}
.language-area label{
  margin-right: 15px;
}
.login-form-wrapper{
  width: 500px;
  margin: auto;
  position: relative;
}
.flagClass{
  width: 24px;
  height: 18px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Page/Login.vue